export class SetAvailableLocations {
  public static readonly type = '[Core] Set Available Program Locations';
  constructor(public locations: number[]) { }
}

export class SetProgressSpinnerVisiblity {
  public static readonly type = '[Interceptor] Set Progress Spinner Visbility';
  constructor(public showSpinner: boolean) { }
}
